module.exports = __webpack_public_path__ + "img/cooperate_9.eb95e7f4.png";